import { css } from '@emotion/core';
import { variables, tokens, shadow } from '@domain-group/fe-brary';
import { designTokenFonts, truncateLines } from '@domain-group/fe-co-allhomes-design-system';
var font = variables.font,
  global = variables.global;
var colors = tokens.colors,
  shadows = tokens.shadows,
  spacing = tokens.spacing;
var _ref = {
  name: "1sojic7",
  styles: "flex-direction:column;height:fit-content;"
};
export var searchResultCard = appearance => /*#__PURE__*/css("display:flex;position:relative;flex-direction:row;align-items:flex-start;justify-content:space-between;border:1px solid ", colors.neutral.trim.default, ";background-color:", colors.neutral.surface.default, ";overflow:hidden;text-decoration:none;height:174px;&:hover{box-shadow:", shadow(shadows.elevation4), ";}", appearance === 'vertical' && _ref, " ", appearance !== 'vertical' && /*#__PURE__*/css("border-radius:", spacing.xs, ";"));
var _ref2 = {
  name: "19midj6",
  styles: "padding:16px;"
};
export var content = (appearance, isNew) => /*#__PURE__*/css("display:flex;flex-direction:column;width:100%;flex-grow:1;gap:16px;", (appearance === 'vertical' || !isNew) && _ref2);
export var detailsAgency = {
  name: "uc5ga5",
  styles: "display:flex;flex-direction:row;flex-grow:1;justify-content:space-between;"
};
var _ref3 = {
  name: "r1l5j9",
  styles: "gap:12px;"
};
var _ref4 = {
  name: "19midj6",
  styles: "padding:16px;"
};
export var details = (appearance, isNew) => /*#__PURE__*/css("display:flex;flex-direction:column;flex-grow:1;background-color:", colors.neutral.surface.default, ";color:", colors.neutral.heavy.default, ";align-items:flex-start;padding-bottom:16px;", appearance === 'horizontal' && _ref3, " ", appearance === 'horizontal' && isNew && _ref4);
export var shareFeature = /*#__PURE__*/css("display:inline-block;font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";color:", colors.neutral.medium.default, ";");
export var sharePeopleWanted = /*#__PURE__*/css(shareFeature, " margin-left:16px;");
export var shareValue = /*#__PURE__*/css("font-weight:", font.headingFontWeight, ";");
export var nextInspection = appearance => /*#__PURE__*/css("height:24px;width:", appearance === 'horizontal' ? 'fit-content' : 'auto', ";");
var _ref5 = {
  name: "70qvj9",
  styles: "display:flex;align-items:center;"
};
export var detailsNextInspection = appearance => /*#__PURE__*/css("font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";color:", colors.neutral.heavy.default, ";background-color:", colors.neutral.subdued.default, ";padding:0 16px;", appearance === 'horizontal' && _ref5);
export var link = {
  name: "1que1r7",
  styles: "text-decoration:none;color:inherit;&::before{position:absolute;top:0;right:0;left:0;bottom:0;content:'';}"
};
export var detailsPrice = /*#__PURE__*/css(truncateLines(1), " ", designTokenFonts.displaySmall, " color:", colors.neutral.heavy.default, ";");
var _ref6 = {
  name: "8atqhb",
  styles: "width:100%;"
};
export var image = appearance => /*#__PURE__*/css("display:block;position:relative;", appearance === 'vertical' && _ref6);
export var pills = /*#__PURE__*/css("display:flex;width:100%;gap:8px;flex-wrap:wrap;z-index:", global.layerOverlay, ";");
export var badges = /*#__PURE__*/css("position:absolute;padding:", tokens.spacing.xxs, ";width:calc(100% - 25px);");
export var verticalAgencyLogo = {
  name: "17bx3ci",
  styles: "border-radius:3px;max-height:30px;max-width:95px;"
};